/* eslint-disable @typescript-eslint/no-explicit-any */

import { useCallback } from 'react';
import { eventsController } from './eventsController';
import { usePanelIdentity } from '../common/usePanelIdentity';

/**
 * Este hook devuelve un método que puede ser llamado para emitir un evento en
 * el panel desde el cual es llamado. Los eventos de panel son emitidos con id
 * de panel, tipo de panel, nombre de panel y tipo de evento y las suscripciones
 * pueden ser realizadas a un conjunto arbitrario de estos identificadores.
 *
 * El segundo parámetro del método fireEvent devuelto es el payload, que puede
 * ser de cualquier tipo.
 */
export function usePanelFireEvent() {
  const { panelId, panelName, panelType, panelTitle } = usePanelIdentity();

  const fireEvent = useCallback(
    (eventType: string, payload: any) => {
      eventsController.fireEvent(
        { panelId, panelName, panelType, panelTitle },
        eventType,
        payload,
      );
    },
    [panelId, panelName, panelType, panelTitle],
  );

  return fireEvent;
}
